

















































































































































































import { ListModel } from "@/shared/models/listModel";
import { Component, Prop, Ref, Vue, Watch } from "vue-property-decorator";
import { PropertyDescriptionModel } from "./types";
import RightDrawer from "@/components/misc/RightDrawer.vue";
import { Notification } from "@/store/modules/notifications";
import { LanguageView } from "@/shared/models/languages";
import { Action, Getter } from "vuex-class";
import FormDescription from "@/components/misc/FormDescription.vue";

@Component({
  components: {
    RightDrawer,
    FormDescription,
  },
})
export default class DescriptionsTiles extends Vue {
  @Prop() propertyId?: number;

  descriptions: PropertyDescriptionModel[] = [];
  loading = true;

  formOpen = false;
  isFormValid = false;
  submiting = false;
  form = new PropertyDescriptionModel(0);
  initialForm = new PropertyDescriptionModel(0);

  required(v: any) {
    return v ? true : this.$t("Validation.Required");
  }
  maxLength(max: number) {
    return (v: string) =>
      v.length <= max ? true : this.$t("Validation.MaxLength", { count: max });
  }

  @Action("codebooks/refreshLanguages") refreshLanguages?: () => Promise<void>;
  @Getter("codebooks/languages") languages?: LanguageView[];

  async created() {
    const promises = [];

    if ((this.languages?.length ?? 0) === 0 && this.refreshLanguages) {
      promises.push(this.refreshLanguages());
    }

    await Promise.all(promises);
  }

  @Watch("propertyId", { immediate: true })
  load() {
    if (!this.propertyId) return;

    this.axios
      .get<ListModel<PropertyDescriptionModel>>(
        `/properties/${this.propertyId}/descriptions`
      )
      .then(
        ({ data }) =>
          (this.descriptions = data.result.map((x) =>
            Object.assign(new PropertyDescriptionModel(this.propertyId ?? 0), x)
          ))
      )
      .finally(() => (this.loading = false));
  }

  @Ref("formRef") formRef?: {
    resetValidation: () => void;
    validate: () => boolean;
  };

  add() {
    this.formRef?.resetValidation();
    this.form = new PropertyDescriptionModel(this.propertyId ?? 0);
    this.initialForm = new PropertyDescriptionModel(this.propertyId ?? 0);
    this.formOpen = true;
  }

  update(desc: PropertyDescriptionModel) {
    this.formRef?.resetValidation();
    this.form = Object.assign(
      new PropertyDescriptionModel(this.propertyId ?? 0),
      desc
    );
    this.initialForm = Object.assign(
      new PropertyDescriptionModel(this.propertyId ?? 0),
      desc
    );
    this.formOpen = true;
  }

  submit() {
    if (this.submiting) {
      return;
    }

    if (!this.formRef?.validate()) {
      this.$store.dispatch("showNotification", {
        color: "error",
        message: this.$t("Changes are invalid or incomplete"),
        timeout: 5000,
      });

      return;
    }

    this.submiting = true;
    if (this.form.id) {
      // update
      this.axios
        .put(
          `/properties/${this.propertyId}/descriptions/${this.form.id}`,
          this.form
        )
        .then(() => {
          const idx = this.descriptions.findIndex((d) => d.id === this.form.id);
          if (idx !== -1) {
            this.descriptions.splice(idx, 1, this.form);
          }
          this.formOpen = false;
        })
        .finally(() => (this.submiting = false));
    } else {
      // add
      this.axios
        .post<number>(`/properties/${this.propertyId}/descriptions`, this.form)
        .then((x) => {
          this.form.id = x.data;
          this.descriptions.push(this.form);
          this.formOpen = false;
        })
        .finally(() => (this.submiting = false));
    }
  }

  remove(desc: PropertyDescriptionModel) {
    this.$store.dispatch("showNotification", {
      id: desc.id,
      color: "warning",
      message: this.$t("PropertyDescription.DeleteConfirmation", {
        value: this.$t(this.langTr(desc.cultureCode)),
      }),
      actions: [
        {
          text: this.$t("Delete"),
          fun: () => {
            this.deleteConfirmed(desc.id);
            return true;
          },
        },
        {
          text: this.$t("Cancel"),
          fun: () => {
            return true;
          },
        },
      ],
      timeout: 30000,
    } as Notification);
  }
  deleteConfirmed(id: number) {
    Vue.axios
      .delete(`/properties/${this.propertyId}/descriptions/${id}`)
      .then(() => {
        const toRemove = this.descriptions.find((x) => x.id === id);
        if (toRemove) {
          this.descriptions = this.descriptions.filter((x) => x.id !== id);
          this.$store.dispatch("showNotification", {
            color: "success",
            message: this.$t("PropertyDescription.DeleteSuccess", {
              value: this.$t(this.langTr(toRemove.cultureCode)),
            }),
            timeout: 5000,
          } as Notification);
        }
      });
  }

  langTr(code: string) {
    return (
      this.languages?.find((x) => x.languageCode === code)?.textResourceKey ??
      code
    );
  }

  fillCardText(desc: PropertyDescriptionModel) {
    if(desc.shortPropertyDescription != "")
    {
      return desc.shortPropertyDescription;
    }
    for (let index = 0; index < Object.entries(desc).length; index++) {
      const el = Object.entries(desc)[index];
      if(!el[0].includes("cultureCode") && typeof(el[1]) === "string" && el[1] != "")
      {
        return el[1];
      }
    }
    return this.$t("DescriptionIsEmpty");
  }
}
